// src/modules/restaurant/pages/respayment/hooks/usePaymentTheme.ts
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { textColorOptions, borderHighlightOptions } from "src/shared/modules/profile/theme/themeConstants";

export const usePaymentTheme = () => {
  const { themeKey, bgClass, fontClass, sidebarThemeClass } = useUserTheme();

  const themeBorderColor = borderHighlightOptions[themeKey]?.split(" ")[0] || "border-blue-500";
  const themeTextColor = textColorOptions[themeKey] || "text-blue-600";
  const themeRingColor = borderHighlightOptions[themeKey]?.split(" ")[1] || "ring-blue-200";

  const getBgClass = () => {
    if (!bgClass) return "bg-blue-600";
    return bgClass?.split(" ")[0] || "bg-blue-600";
  };

  const getLightBgClass = () => {
    if (!bgClass) return "bg-blue-100";
    
    const baseColor = bgClass?.split(" ")[0]; // e.g. "bg-blue-600"
    if (!baseColor) return "bg-blue-100";
    
    const colorParts = baseColor.replace("bg-", "").split("-");
    const colorName = colorParts[0];
    
    // Handle cases where color name might be undefined
    if (!colorName) return "bg-blue-100";
    
    return `bg-${colorName}-100`;
  };

  return {
    themeKey,
    fontClass,
    themeBorderColor,
    themeTextColor,
    themeRingColor,
    getBgClass,
    getLightBgClass,
    sidebarThemeClass,
  };
};